import { isField } from '../../types/field';
import { getCustomFormat } from '../../utils/formatting';
import { getItemLabelWithoutTableName } from '../../utils/item';
/** Normalize one binding for consumers that handle either cardinality. */
export const getDataAppVizFieldIds = (value) => typeof value === 'string' ? [value] : [...new Set(value ?? [])];
/** Display metadata for every bound field id the items map can describe. */
export const deriveDataAppVizFieldMetadata = (fieldMapping, itemsMap) => Object.fromEntries(Object.values(fieldMapping)
    .flatMap(getDataAppVizFieldIds)
    .flatMap((fieldId) => {
    const item = itemsMap[fieldId];
    if (!item)
        return [];
    const format = getCustomFormat(item);
    const metadata = {
        label: getItemLabelWithoutTableName(item),
        ...(isField(item) ? { tableLabel: item.tableLabel } : {}),
        ...(format ? { format } : {}),
    };
    return [[fieldId, metadata]];
}));
//# sourceMappingURL=dataAppVizFieldMapping.js.map